import * as yup from "yup";
import { alphaNumericPattern, emailrgx } from "../assets/constant";
import { countries } from "../assets/nationalities"; 
export const schema = (t) =>
  yup
    .object({
      companyname: yup
        .string()
        .trim()
        .matches(alphaNumericPattern, t("Please enter a valid company name"))
        .required(t("Please enter the company name"))
        .min(3, t('Company name must be at least 2 characters')),
      region: yup
        .string()
        .trim()
        .required(t("Country is required"))
        .oneOf(
          countries,
          t("Invalid Country selected")
        ),
    name: yup
      .string()
      .trim()
      .matches(alphaNumericPattern, t("Please enter a valid name"))
      .required(t("Please enter your name"))
      .min(3, t('Name must be at least 3 characters')),
    email: yup
      .string()
      .email(t("Invalid email format")) // Use built-in email validation
      .required(t("Email is required"))
      .trim(),
    password1: yup
      .string()
      .min(6, t("Password must be at least 6 characters"))
      .required(t("Password is required"))
      .trim(),
    password2: yup
      .string()
      .oneOf([yup.ref("password1")], t("Passwords must match"))  // Correct reference
      .required(t("Confirm password is required")),
    phone: yup
      .string()
      .trim()
      .matches(/^\+\d{1,4}\d{6,14}$/, t("Please enter a valid international phone number that starts with +"))
      .required(t("Contact number is required")),
    street: yup
      .string()
      .required(t('Street is required'))
      .min(2, t('Street / Building / House No, must be at least 2 characters')),
    postal_code: yup
      .string()
      .trim()
      .required(t('Postal Code is required'))
      .matches(/^\d{4,6}$/, t('Postal Code must be 4 to 6 digits')),





    imgprofile: yup
      .mixed()
      .nullable()
      .notRequired()
      .test('fileSize', t('The file is too large (max 2MB)'), value => {
        if (!value || typeof value === 'string') return true;
        const file = value instanceof FileList ? value[0] : value;
        if (!file) return true;
        return file.size <= 2 * 1024 * 1024;
      })
      .test('fileType', t('Unsupported file format'), value => {
        if (!value || typeof value === 'string') return true;
        const file = value instanceof FileList ? value[0] : value;
        if (!file) return true;
        return ['image/jpeg', 'image/png', 'image/svg+xml'].includes(file.type);
      }),

      recaptcha: yup
        .string()
        .required(t("ReCAPTCHA is required"))
})